import {
  messageLinks,
  type QuestionnaireNotDonePart,
  type TestedAssetType,
} from "@digital-twins/shared-types";

/** A link a reply's not-done part hands to the builder's asset-confirm card. */
export interface HandedOverLink {
  url: string;
  family: TestedAssetType;
}

/**
 * The links a reply's not-done parts hand over (QA4): the model decided the
 * user gave them as material, and the builder offers its card for each. A
 * part's link counts only when it is one of the links in the user's message
 * the reply answers, both read by the one URL parser (`messageLinks`): a link
 * the user never wrote is never captured (literal provenance). Any other
 * not-done part stays a line of the reply.
 */
export function handedOverLinks(
  parts: ReadonlyArray<QuestionnaireNotDonePart>,
  userMessage: string,
): { links: Array<HandedOverLink>; lines: Array<QuestionnaireNotDonePart> } {
  const given = messageLinks(userMessage);
  const links: Array<HandedOverLink> = [];
  const lines: Array<QuestionnaireNotDonePart> = [];
  for (const part of parts) {
    const [written] = part.link ? messageLinks(part.link.url) : [];
    const url = written
      ? given.find((link) => link.toLowerCase() === written.toLowerCase())
      : undefined;
    if (url && part.link) {
      links.push({ url, family: part.link.assetType });
    } else {
      lines.push(part);
    }
  }
  return { links, lines };
}
